module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "banner_nav_arrow.162c0ea1.svg";